'use client';
import Link from 'next/link';
import Image from 'next/image';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';

import { ContentRenderer } from '@portal/content-renderer';
import { blogPostUrl, testUrl } from 'src/services/route-utils';
import LogoWatermark from 'public/images/logo-watermark.svg';

type Props = {
    content: any;
};

export default function ExtendedContentRenderer({ content }: Props) {
    const renderers = {
        inline: {
            relationship({ relationship, data }) {
                if (relationship === 'test') {
                    if (data === null || data.data === undefined) {
                        return <span>[unknown test]</span>;
                    } else {
                        return (
                            <Link className="test-link" href={testUrl(data.data)}>
                                {data.data.name} <HiOutlineArrowNarrowRight className="inline text-lg" />
                            </Link>
                        );
                    }
                }

                return null;
            },
        },
    };

    const componentBlocks = {
        blogPosts: (props) => {
            if (!props.posts?.length) return null;

            return (
                <section className="bg-light-grey relative my-4 overflow-hidden py-4 md:my-8 md:py-8">
                    <LogoWatermark className="absolute bottom-0 right-0 origin-bottom-right scale-50 opacity-50 md:transform-none" />
                    <div className="bg-primary mb-4 inline-block px-4 py-1 text-xs text-white md:mb-8 md:px-8 md:text-sm">
                        {props.title}
                    </div>
                    <div className="items-center gap-16 px-4 md:px-8 xl:my-4 xl:flex">
                        {props.posts.map((item) => (
                            <div
                                key={item.id}
                                className={`group mb-4 flex items-center gap-4 last:mb-0 ${
                                    props.posts.length === 1 ? 'xl:w-2/3' : 'xl:w-1/2'
                                }`}>
                                <Link href={blogPostUrl(item.data)} className="w-24 md:w-32">
                                    <Image
                                        width={128}
                                        height={128}
                                        className="bg-primary m-0!"
                                        src={item.data.cover_image.thumbnail}
                                        placeholder={item.data.cover_image.placeholder}
                                        alt={item.data.name}
                                    />
                                </Link>

                                <div className="flex-1">
                                    <a
                                        className="font-display reset-a text-primary line-clamp-3 flex-1 text-xl no-underline decoration-1 underline-offset-4 group-hover:underline md:text-2xl xl:text-3xl"
                                        href={blogPostUrl(item.data)}>
                                        {item.data.name}
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            );
        },
    };

    return <ContentRenderer content={content} renderers={renderers} componentBlocks={componentBlocks} />;
}
